import type { ReactNode } from 'react';

import { Button, type Props as ButtonProps } from '../Dropdown/Button';
import { Dropdown, type Props as DropdownProps } from '../Dropdown/Dropdown';
import { Menu, type Props as MenuProps } from '../Dropdown/Menu';

type Props = Omit<ButtonProps, 'children'> &
    Omit<DropdownProps, 'className' | 'children'> & {
        children: MenuProps['children'];
        label?: ReactNode;
        menuClassName?: MenuProps['className'];
        popperClassName?: MenuProps['popperClassName'];
        menuPlacement?: MenuProps['placement'];
    };

export function DropdownButton({
    autoClose,
    children,
    label,
    menuClassName,
    popperClassName,
    menuPlacement,
    onToggle,
    ...buttonProps
}: Props) {
    return (
        <Dropdown autoClose={autoClose} onToggle={onToggle}>
            <Button {...buttonProps}>{label}</Button>
            <Menu
                className={menuClassName}
                popperClassName={popperClassName}
                placement={menuPlacement}
            >
                {children}
            </Menu>
        </Dropdown>
    );
}
